import { render } from "./RevenueDashboard.vue?vue&type=template&id=0692825a&scoped=true&ts=true"
import script from "./RevenueDashboard.vue?vue&type=script&lang=ts"
export * from "./RevenueDashboard.vue?vue&type=script&lang=ts"

import "./RevenueDashboard.vue?vue&type=style&index=0&id=0692825a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0692825a"]])

export default __exports__